import store from '@/store';
import get from 'get-object-path';

export function canViewLudumFeature(featureId, club = null) {
    const clubToCheck = club || store.getters.selectedClub;
    if (!clubToCheck) return false;
    const features = get(clubToCheck, 'club.data.subscription_info.data.subscription_plan.data.features.data') || [];
    return !!features.find(({ subscription_feature_id }) => subscription_feature_id === featureId);
}
